export default {
  mainCategories: [
    "c-1",
    "c-1-b-1",
    "c-1-b-2",
    "c-1-b-3",
    "c-2",
    "c-2-b-1",
    "c-2-b-2",
    "c-2-b-3",
    "c-2-b-4",
    "c-2-b-5",
    "c-2-b-6",
    "c-2-b-7",
    "c-2-b-8",
    "c-2-b-9",
    "c-2-b-10",
    "c-3",
    "c-3-b-1",
    "c-3-b-2",
    "c-3-b-3",
  ],
  subCategories: {
    "c-1-b-1": [
      "c-1-b-1-s-1",
      "c-1-b-1-s-2",
      "c-1-b-1-s-3",
      "c-1-b-1-s-4",
      "c-1-b-1-s-5",
      "c-1-b-1-s-6",
      "c-1-b-1-s-7",
      "c-1-b-1-s-8",
      "c-1-b-1-s-9",
      "c-1-b-1-s-10",
      "c-1-b-1-s-11",
      "c-1-b-1-s-12",
    ],
    "c-1-b-2": [
      "c-1-b-2-s-1",
      "c-1-b-2-s-2",
      "c-1-b-2-s-3",
      "c-1-b-2-s-4",
      "c-1-b-2-s-5",
      "c-1-b-2-s-6",
      "c-1-b-2-s-7",
      "c-1-b-2-s-8",
    ],
    "c-1-b-3": ["c-1-b-3-s-1", "c-1-b-3-s-2", "c-1-b-3-s-3"],
    "c-2-b-1": [
      "c-2-b-1-s-1",
      "c-2-b-1-s-2",
      "c-2-b-1-s-3",
      "c-2-b-1-s-4",
      "c-2-b-1-s-5",
      "c-2-b-1-s-6",
      "c-2-b-1-s-7",
    ],
    "c-2-b-2": ["c-2-b-2-s-1", "c-2-b-2-s-2"],
    "c-2-b-3": ["c-2-b-3-s-1", "c-2-b-3-s-2", "c-2-b-3-s-3", "c-2-b-3-s-4"],
    "c-2-b-4": ["c-2-b-4-s-1"],
    "c-2-b-5": ["c-2-b-5-s-1", "c-2-b-5-s-2", "c-2-b-5-s-3", "c-2-b-5-s-4"],
    "c-2-b-6": ["c-2-b-6-s-1", "c-2-b-6-s-2", "c-2-b-6-s-3", "c-2-b-6-s-4"],
    "c-2-b-7": ["c-2-b-7-s-1", "c-2-b-7-s-2", "c-2-b-7-s-3"],
    "c-2-b-8": ["c-2-b-8-s-1"],
    "c-2-b-9": ["c-2-b-9-s-1"],
    "c-3-b-1": [
      "c-3-b-1-s-1",
      "c-3-b-1-s-2",
      "c-3-b-1-s-3",
      "c-3-b-1-s-4",
      "c-3-b-1-s-5",
      "c-3-b-1-s-6",
      "c-3-b-1-s-7",
    ],
    "c-3-b-2": ["c-3-b-2-s-1", "c-3-b-2-s-2", "c-3-b-2-s-3", "c-3-b-2-s-4"],
    "c-3-b-3": ["c-3-b-3-s-1", "c-3-b-3-s-2", "c-3-b-3-s-3"],
  },
};
